 

export const ROUTER_CONSTANTS = {
    ADMIN: {
        TenantApiSecurityDefinition: 'account-tenant-api-security-definition',
        TenantApiSecurityDefinitionEdit: 'account-tenant-api-security-definition/:id',
        AccountTenantApiSecurity:'account-tenant-api-security-list',
        AccountDataTransferHistory:'account-data-transfer-history',
        AccountList: 'account-list',
        AccountManagement: 'account-definition/',
        AccountManagementEdit: 'account-definition/:id',
        AccountParameterList: 'account-parameter-list/',
        AccountRelations: "account-relations",
        AccountRelationRequests: "account-relation-requests",
        AccountListByType: "account-list-by-type/:accountType", 
        ApplicationModules: "application/modules", 
        ApplicationModuleCreate: "application/modules/create", 
        ApplicationModuleEdit: "application/modules/:id", 
        ApplicationFeatures: "application/features", 
        ApplicationFeatureCreate: "application/features/create", 
        ApplicationFeatureEdit: "application/features/:id",
        ProductApprovals: 'product-approvals',
        AuditLogList: 'audit-log-list',
        CityDefinition: 'city-definition',
        CityDefinitionEdit: 'city-definition/:id',
        CityList: 'city-list',
        CountryDefinition: 'country-definition',
        CountryDefinitionEdit: 'country-definition/:id',
        CountryList: 'country-list',
        HomePage: 'home',
        MenuDefinition: 'application/menus/create',
        MenuDefinitionEdit: 'application/menus/:id',
        MenuList: 'application/menus',
        ParameterDefinition: 'parameter-definition',
        ParameterDefinitionEdit: 'parameter-definition/:id',
        Parameters: 'parameters',
        Permissions: "application/permissions", 
        PermissionCreate: "application/permissions/create", 
        PermissionEdit: "application/permissions/:id", 
        ResourceDefinition: 'resource-definition',
        ResourceDefinitionEdit: 'resource-definition/:id',
        ResourceList: 'resource-list',
        RoleDefinition: 'role-definition',
        RoleDefinitionEdit: 'role-definition/:id',
        RoleList: 'role-list',
        UserList: 'user-list',
        UserDefinition: 'user-definition/',
        UserDefinitionEdit: 'user-definition/:id',
        UserEventList: 'user-event-list',
        NotificationList:'notification-list',
        EmailNotificationManagement:'email-notification-definition/',
        EmailNotificationManagementEdit:'email-notification-definition/:id',
        EmailNotificationList:'email-notification-list',
        DocumentTemplateDefinition:'document-template-definition',
        DocumentTemplateDefinitionEdit:'document-template-definition/:id',
        DocumentTemplateList:'document-template-list'
    },
    Nothing: ' ',
    OrderRecommendationList: 'order-recommendation-list',
    SupplierOrderList: "supplier-order-list",
    SupplierOrderDetailList: "supplier-order-detail-list/:id",
    ListRetailerOrders: 'retailer-order-list',
    OrderManagementEdit: 'order-management/:id',
    OrderManagement: 'order-management',
    ProductHasFeatureList: 'product-has-feature-list',
    ProductHasFeatureDefinition: 'product-has-feature-definition',
    ProductHasFeatureDefinitionEdit: 'product-has-feature-definition/:id',
    ProductDefinitionManagementEdit: 'product-definition/:id',
    ProductDefinitionManagement: 'product-definition',
    ImportProduct: 'import-product',
    SupplierImportProduct: 'supplier-import-product',
    ProductList: 'product-list',
    ProductFeatureList: 'product-feature-list',
    ProductFeatureDefinition: 'product-feature-definition',
    ProductFeatureDefinitionEdit: 'product-feature-definition/:id',
    ProductGroupList: 'product-group-list',
    ProductGroupDefinition: 'product-group-definition',
    ProductGroupDefinitionEdit: 'product-group-definition/:id',
    Parameters: 'parameters',
    RoleDefinition: 'role-definition',
    RoleDefinitionEdit: 'role-definition/:id',
    RoleList: 'role-list',
    AccountParameterList: 'account-parameter-list/',
    AccountManagement: 'account-definition/',
    AccountManagementEdit: 'account-definition/:id',
    AccountList: 'account-list',
    UserList: 'user-list',
    UserDefinitionBackup: 'user-definition-backup',
    UserDefinitionEdit: 'user-definition/:id',
    UserDefinition: 'user-definition/',
    PowerBiPerformanceReports: 'power-bi-sales-performance-report',
    PowerBiLiveSalesReports: 'power-bi-live-sales-report',
    PowerBiStockReports: 'power-bi-stock-report',
    PowerBiBonibiReports: 'power-bi-bonibi-report',
    PowerBiPhilipMorrisReports: 'power-bi-philip-morris-sales-report',

    NewPowerBiPerformanceReports: 'new-power-bi-sales-performance-report',
    NewPowerBiLiveSalesReports: 'new-power-bi-live-sales-report',
    NewPowerBiStockReports: 'new-power-bi-stock-report',
    NewPowerBiBonibiReports: 'new-power-bi-bonibi-report',

    DemoPowerBiPerformanceReports: 'demo-power-bi-sales-performance-report',
    DemoPowerBiLiveSalesReports: 'demo-power-bi-live-sales-report',
    DemoPowerBiStockReports: 'demo-power-bi-stock-report',

    SupersetDashboards: 'superset-sales-performance-dashboard',
    SupersetLiveSalesDashboard: 'superset-live-sales-dashboard',
    SupersetStockDashboard: 'superset-stock-dashboard',
    MstrSalesPerformance: 'mstr-sales-performance-dashboard',
    MstrLiveSales: 'mstr-live-sales-dashboard',
    MstrStock: 'mstr-stock-dashboard',
    MstrSalesDetailAnaylsis: 'mstr-sales-detail-analysis',
    MstrLFLSalesReport: 'mstr-lfl-sales-report',
    SalesPerformanceReport: 'sales-performance-report',
    ProfilePage: 'profile',
    HomePage: 'home',
    MenuList: 'menu-list',
    MenuDefinition: 'menu-definition',
    MenuDefinitionEdit: 'menu-definition/:id',
    RetailerSupplierManagement: 'retailer/supplier-management',
    RetailerProductManagement: 'retailer/product-management',
    RetailerProductDefinitionEdit: 'retailer/product-definition/:id',
    RetailerProductDefinitionAdd: 'retailer/product-definition',
    RetailerProductList: 'retailer/product-list',
    RetailerLocationList: 'retailer/location-list',
    RetailerRegionList: 'retailer/region-list',
    RetailerEmailList: 'retailer/email-list',
    SupplierRetailerProductList: 'supplier/retailer-product-list',
    CityList: 'city-list',
    CityDefinition: 'city-definition',
    CityDefinitionEdit: 'city-definition/:id',
    CountryList: 'country-list',
    CountryDefinition: 'country-definition',
    CountryDefinitionEdit: 'country-definition/:id',
    ParameterDefinitionEdit: 'parameter-definition/:id',
    ParameterDefinition: 'parameter-definition',
    ImportProductGroup: 'import-product-group',
    ImportRetailerSupplierLocations: 'retailer-supplier-location-import',
    RetailerSupplierLocationList: 'retailer-supplier-location-list',
    SupplierRetailerList: 'supplier-retailer-list',
    AccountRelations: 'account-relations',
    Profile:'profile/*',
    SYNCFLOW: {
        Preorder: 'preorders',
        OrderList: 'order-list',
        OrderDetail: 'order-detail/:id',
        OrderSetting: 'order-setting',
        VendorSupplyParameter: 'vendor_supply_parameter',
        VendorSupplyParameterAdd: 'vendor_supply_parameter_definition',
        VendorSupplyParameterEdit: 'vendor_supply_parameter_definition/:id',
        ProductSupplyParameter: 'product_supply_parameter',
        VendorAdd: 'vendor-detail',
        VendorDetail: 'vendor-detail/:id',
        InvoiceList: 'invoice-list',
        InvoiceRecording: 'invoice-recording',
        InvoiceDetail: 'invoice-recording/:id', 
        PaymentCalender: 'payment-calender',
        InventoryList: 'inventory-list',
        InventoryDetail: 'inventory-detail/:sitecode/:productcode',  
        SupplierOrderList: "supplier-order-list",
        SupplierOrderDetailList: "supplier-order-detail-list/:id",
        
         
        ParameterList: 'parameter-list',
       
        AdditionalOrder: 'additional-order',
        AdditionalOrderDetai: 'additional-order/:id',
        Balance:"balance",
        ForecastList:"forecast-list",
        WaybillList: 'waybill-list',
        WaybillAdd: 'waybill-add',
        WaybillDetail: 'waybill-add/:id',
        ProductPortfolio: 'product-portfolio',
        ProductRecipe: 'product-recipe',
        SupplierList: 'supplier-list'
     },
    PROMNI: {
        CampaignList: 'campaign/campaign-list',
        CampaignWizard: 'campaign/campaign-wizard'
        

      

    },
    B2BSTORE: {
        Store: 'store',
        SearchResult: 'search-result/:q',
        CheckoutSummary: 'checkout/summary',
        CheckoutComplete: 'checkout/completed',
        OrderHistory: "order/history"
    },
   

}  